import React, { Fragment } from "react";

import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";

import PerfectScrollbar from "react-perfect-scrollbar";

const Timeline = ({ data }) => {
  return (
    <Fragment>
      <div className="scroll-area-sm">
        <PerfectScrollbar>
          <div className="p-3">
            <VerticalTimeline
              className="vertical-time-simple vertical-without-time"
              layout="1-column"
            >
              {data.slice(0, 5).map(item => (
                <VerticalTimelineElement key={item.uuid}>
                  <div className="d-flex flex-column">
                    <h4 className="timeline-title">{item.description}</h4>
                    <small>
                      Autor:{" "}
                      <b className="text-danger">{item.createdBy.name}</b>
                    </small>
                  </div>
                </VerticalTimelineElement>
              ))}
              {/* <VerticalTimelineElement className="vertical-timeline-item">
                <h4 className="timeline-title">All Hands Meeting</h4>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <p>
                  Another meeting today, at{" "}
                  <b className="text-danger">12:00 PM</b>
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <h4 className="timeline-title">Build the production release</h4>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <h4 className="timeline-title">All Hands Meeting</h4>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <h4 className="timeline-title text-success">
                  FontAwesome Icons
                </h4>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <h4 className="timeline-title">Build the production release</h4>
              </VerticalTimelineElement>
              <VerticalTimelineElement className="vertical-timeline-item">
                <p>
                  Another meeting today, at{" "}
                  <b className="text-warning">12:00 PM</b>
                </p>
              </VerticalTimelineElement> */}
            </VerticalTimeline>
          </div>
        </PerfectScrollbar>
      </div>
    </Fragment>
  );
};

export default Timeline;
